import {
  SITE_URL,
  SITE_NAME,
  SITE_OG_IMAGE,
  DEFAULT_DESCRIPTION,
  resolvePageSeo
} from '@/constants/siteSeo'
import { MARKETING_FAQS } from '@/constants/marketingFaq'
import { RECHARGE_PACKAGES } from '@/constants/rechargePackages'
import { buildFaqPageSchema, buildPricingItemListSchema } from '@/utils/seoSchema'

function upsertMeta(attr, key, content) {
  if (!content) return
  let el = document.head.querySelector(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function upsertDocumentH1(text) {
  if (!text) return
  let el = document.getElementById('seo-h1')
  if (!el) {
    el = document.createElement('h1')
    el.id = 'seo-h1'
    document.body.insertBefore(el, document.getElementById('app'))
  }
  el.textContent = text
}

function upsertLink(rel, href) {
  if (!href) return
  let el = document.head.querySelector(`link[rel="${rel}"]`)
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', rel)
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

function upsertJsonLd(id, data) {
  let el = document.getElementById(id)
  if (!el) {
    el = document.createElement('script')
    el.type = 'application/ld+json'
    el.id = id
    document.head.appendChild(el)
  }
  el.textContent = JSON.stringify(data)
}

function removeJsonLd(id) {
  const el = document.getElementById(id)
  if (el) el.remove()
}

function buildOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': `${SITE_URL}/#organization`,
    name: SITE_NAME,
    url: SITE_URL,
    logo: `${SITE_URL}/favicon.png`,
    description: DEFAULT_DESCRIPTION,
    email: 'bixinpaper@126.com'
  }
}

function buildWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': `${SITE_URL}/#website`,
    name: SITE_NAME,
    url: SITE_URL,
    description: DEFAULT_DESCRIPTION,
    publisher: { '@id': `${SITE_URL}/#organization` }
  }
}

/**
 * 根据路由更新 title / meta / canonical / JSON-LD
 */
export function applyRouteSeo(route) {
  const path = route.path || '/'
  const seo = resolvePageSeo(path)
  const canonicalUrl = `${SITE_URL}${path === '/' ? '/' : path}`

  document.title = seo.title
  upsertDocumentH1(seo.h1)

  upsertMeta('name', 'description', seo.description)
  upsertMeta('name', 'keywords', seo.keywords)
  upsertMeta('name', 'robots', seo.robots || 'index, follow')

  upsertMeta('property', 'og:type', 'website')
  upsertMeta('property', 'og:site_name', SITE_NAME)
  upsertMeta('property', 'og:title', seo.title)
  upsertMeta('property', 'og:description', seo.description)
  upsertMeta('property', 'og:url', canonicalUrl)
  upsertMeta('property', 'og:image', SITE_OG_IMAGE)
  upsertMeta('property', 'og:image:width', '1200')
  upsertMeta('property', 'og:image:height', '630')
  upsertMeta('property', 'og:locale', 'zh_CN')

  upsertMeta('name', 'twitter:card', 'summary_large_image')
  upsertMeta('name', 'twitter:title', seo.title)
  upsertMeta('name', 'twitter:description', seo.description)
  upsertMeta('name', 'twitter:image', SITE_OG_IMAGE)

  upsertLink('canonical', canonicalUrl)

  if (path === '/') {
    upsertJsonLd('seo-schema-organization', buildOrganizationSchema())
    upsertJsonLd('seo-schema-website', buildWebSiteSchema())
  } else {
    removeJsonLd('seo-schema-organization')
    removeJsonLd('seo-schema-website')
  }

  if (path === '/faq') {
    upsertJsonLd('seo-schema-faq', buildFaqPageSchema(MARKETING_FAQS))
  } else {
    removeJsonLd('seo-schema-faq')
  }

  if (path === '/pricing') {
    upsertJsonLd('seo-schema-pricing', buildPricingItemListSchema(RECHARGE_PACKAGES))
  } else {
    removeJsonLd('seo-schema-pricing')
  }
}
